import { render, staticRenderFns } from "./contact-info-row.vue?vue&type=template&id=2f5f52cf&scoped=true&"
import script from "./contact-info-row.vue?vue&type=script&lang=js&"
export * from "./contact-info-row.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=2f5f52cf&scoped=true&lang=css&"
import style1 from "./contact-info-row.vue?vue&type=style&index=1&id=2f5f52cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5f52cf",
  null
  
)

export default component.exports